import axios from '@/api/axios'

const getEventsAndCompetitionsList = (type, params) => {
  return axios
    .get(`/${type}/listForEventsAndCompetitions`, {params})
    .then((res) => res.data)
}

export default {
  getEventsAndCompetitionsList,
}
